// variables
import { StyledSvgIcon } from 'variables';

// libraries
import styled from 'styled-components';

export const StyledHomeIcon = styled.svg`
  ${StyledSvgIcon}
`;
